import classnames from 'classnames/bind'
import { useMemo } from 'react'

// Libs
import { MenuType, SkuItemInfoType } from '@/api/fetchProductData'

// Constants

// Styles
import styles from './style.module.scss'

// Mock Data

const cx = classnames.bind(styles)

interface SpecsProps {
  menu: MenuType[]
  // onChange: (label: string, index: number) => void
  searchKeyList: string[]
  filteredItems: SkuItemInfoType[]
  handleSearchKeyChange?: any
  skuItemInfo: any
  className?: string
  labelClassName?: string
  isFullScreen?: boolean
}

const Specs = ({ menu, searchKeyList, handleSearchKeyChange, skuItemInfo, className, labelClassName, isFullScreen }: SpecsProps) => {
  // 可購買的 SKU（上架且有庫存），attrId 轉成集合供比對
  const purchasableSkus = useMemo(
    () =>
      ((skuItemInfo || []) as any[])
        .filter((sku) => sku.status === 100 && sku.stockQuantity > 0)
        .map((sku) => new Set<string>(sku.profile?.specs?.map((spec: any) => String(spec.attrId)) || [])),
    [skuItemInfo],
  )

  const matchesSelection = (attrIdSet: Set<string>, selection: string[]) => selection.every((key) => key === '' || attrIdSet.has(key))

  // 其他維度維持現選的情況下，選了這個值是否還有可購買的 SKU
  const isSelectable = (specIndex: number, attrId: string) => {
    const trialSelection = searchKeyList.map((key, index) => (index === specIndex ? attrId : key))
    return purchasableSkus.some((attrIdSet) => matchesSelection(attrIdSet, trialSelection))
  }

  // 這個值在所有組合下都沒有可購買的 SKU
  const isOutOfStockEverywhere = (attrId: string) => !purchasableSkus.some((attrIdSet) => attrIdSet.has(attrId))

  const handleSearch = (attrId: string, specIndex: number) => {
    const newSearchKey = [...searchKeyList]
    newSearchKey[specIndex] = newSearchKey[specIndex] === attrId ? '' : attrId
    handleSearchKeyChange(newSearchKey)
  }

  return (
    <div className={cx('specs', className)}>
      {!(skuItemInfo?.length <= 1) &&
        menu?.map((spec, index) => (
          <div className={cx('specs__wrapper')} key={spec.name}>
            <div className={cx('specs-name', labelClassName, { isFullScreen })}>{spec.name}</div>
            <div className={cx('specs__option-wrapper', { isFullScreen })}>
              {spec.values.map((data) => {
                const attrId = String(data.attrId)
                const isActive = attrId === searchKeyList[index]
                const isSoldOut = isOutOfStockEverywhere(attrId)
                const isDisable = isSoldOut || data.disabled || (!isActive && !isSelectable(index, attrId))

                return (
                  <div
                    className={cx('specs-value', {
                      active: isActive,
                      disable: isDisable,
                      soldOut: isSoldOut,
                      hide: data.hide,
                    })}
                    key={data.attrId}
                    onClick={() => !isDisable && handleSearch(attrId, index)}
                  >
                    <div className={cx('specs-value-text')}>{data.value}</div>
                  </div>
                )
              })}
            </div>
          </div>
        ))}
    </div>
  )
}

export default Specs
